module.exports = __webpack_public_path__ + "img/sh_4.09630654.jpg";